import axios from 'axios';
import authToken from 'js/library/utils/API/authToken';
import cfac22 from '../cfac22';

export default function campaignPolls(uid, campaignId) {
  return new Promise((resolve, reject) => {
    authToken(uid)
      .then((token) => {
        axios
          .get(cfac22('API_HOST_V2') + '/campaignPolls/all?campaignId=' + campaignId, {
            headers: {
              authorization: 'Bearer ' + token,
              'Full-Url': window.location.href,
            },
          })
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            return reject(error.response.data);
          });
      })
      .catch((error) => {
        reject(error.response.data);
      });
  });
}
